export default "__VITE_ASSET__RYVRvbnb__"